<div class="row_1">
    <div>

        <label class="label tab-heading" (click)="openRouteLevel('domicile')">Domicile</label>
        <label class="label tab-heading titlered">Assigned User</label>
        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue()">Add To
            Queue</button>

    </div>

    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="RefreshData()">
        <app-periods-dropdown periodLabel="Period" module="Tiers" class="drpdwn_period_labels"
            (eventHandler)="componentEventHandler($event);">
        </app-periods-dropdown>
        <label class="drpdwn_period_kpi">Tier :</label>
        <select style="font-family:Roboto;font-size:13px" class="drpdwn_period" [(ngModel)]="selected_position_id"
            [ngModelOptions]="{standalone: true}" (change)="onTierChange()">
            <option *ngFor="let Tier of TierData" [value]="Tier.tierPosition">
                {{Tier.description}}
            </option>
        </select>

        <label class="drpdwn_period_label">Round :</label>
        <select style="font-family:Roboto;font-size:13px" class="drpdwn_period" (change)="onRoundChange()"
            [(ngModel)]="selected_round_id" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let round of RoundData" [value]="round">
                {{round}}
            </option>
        </select>

        <label class="drpdwn_period_label">User :</label>
        <!-- <p-multiSelect [options]="selectedUsers" defaultLabel="ALL" [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'" [filter]="true" optionLabel="label" [virtualScroll]="true"
            [(ngModel)]="optionalUsers" (onChange)="onUsersChange()"
            [style]="{'width':'200px', 'height':'26px','font-size':'13px', 'margin-left':'17px'}">
        </p-multiSelect> -->
        <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="optionalUsers" [multiple]="true" placeholder="ALL"
                (selectionChange)="onUsersChange()">
                <mat-option>
                    <div style="display: flex; align-items: center; position: sticky;
                    top: 0;
                    background: white;
                    z-index: 1;">
                        <mat-checkbox
                          style="margin-right: 0px;"
                          [checked]="isAllSelected()"
                          [indeterminate]="isIndeterminate()"
                          (change)="toggleSelectAll($event)">
                        </mat-checkbox>
                    <ngx-mat-select-search [formControl]="userFilterCtrl" placeholderLabel="Search"
                        noEntriesFoundLabel="No users found">
                    </ngx-mat-select-search>
                </div>
                </mat-option>
                <mat-option *ngFor="let user of filteredUsers | async" [value]="user" style="font-size: 13px;">
                    {{ user.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>


        <label class="drpdwn_period_label">KEY: Total/Completed/Ignored</label>
        <img src="./assets/images/export_black.svg" (click)="onBtExport()" class="export-icon">

        <div class="grid-agg">
            <ag-grid-angular #agGrid style="width: 100%; height: 431px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                [columnDefs]="columnDefs" [icons]="icons" [context]="context" (gridReady)="OnGridReady($event);"
                [defaultColDef]="defaultColDef" (window:resize)="sizeToFit()"  
                [enableCellTextSelection]="true" [ensureDomOrder]="true" [pinnedTopRowData]="toprow"
                [suppressDragLeaveHidesColumns]="true" [animateRows]="true" [rowData]="displayRowData"
                [pagination]="true" [paginationPageSize]="rowCount"></ag-grid-angular>

            <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="OnPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="GoToFirstPage()"
                        [ngClass]="{'disable_icon':GetCurrentPage()== true,'enable_icon':GetCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="GoToPreviousPage()"
                        [ngClass]="{'disable_icon':GetCurrentPage()== true,'enable_icon':GetCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':IsLastPage()== true,'enable_icon':IsLastPage()!= true}"
                        (click)="GoToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':IsLastPage()== true,'enable_icon':IsLastPage()!= true}"
                        (click)="GoToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>
        </div>



    </div>
</div>